//
// duplicate the OFI section on the click of the "Add Liability" button
//
import * as setAccesibilityAttributesModule from "./accessibilityCustomLogic";

var duplicateOfiSection = (function () {
    'use strict';

    var $addLiabilityButton = document.querySelectorAll('#add_liability');
    var $container = $(".ofi_liabilities_container");
    var $productsRadioSelector = $("input[name^='products_status']");

    var liabilitiesCount = 0;
    var customCounter = 0;
    var expanderCounter = 1;
    var idsDict = {};

    function checkAndAdjustAttr(attrName, element) {
        if (element.attr(attrName)) {
            var val = element.attr(attrName);

            if (!idsDict[val]) {
                var attrValue = `${val}-custom-${customCounter}`;
                if (attrName == 'aria-describedby') {
                    attrValue += ' dropdown-instructions';
                }
                idsDict[val] = attrValue;
                customCounter++;
            }

            element.attr(attrName, idsDict[val]);
        }

        //clear idsDict
        //for (let prop in idsDict) {
        //    delete idsDict[prop];
        //}
    }

    function fixAttributes(fieldsClone) {
        var elements = [];
        idsDict = {};
        elements.push(fieldsClone);

        // go trough element and it's children using a BFS-like traversal
        while (elements.length) {
            var curr = elements.pop();

            var toCheck = ["id", "data-id", "for", "aria-owns", "aria-describedby", "aria-labelledby"];
            for (var attrId in toCheck) {
                checkAndAdjustAttr(toCheck[attrId], $(curr));
            }

            for (var child of $(curr).children().toArray()) {
                elements.push(child);
            }
        }
    }

    function fixExpanderAttributes(fieldsClone) {
        $(fieldsClone).find('#ofiCollapse').attr('id', 'ofiCollapse-' + expanderCounter);
        $(fieldsClone).find('#ofiHeading').attr('id', 'ofiHeading-' + expanderCounter);
        $(fieldsClone).find("[data-target='#ofiCollapse']").attr("data-target", "#ofiCollapse-" + expanderCounter);
        $(fieldsClone).find("[aria-controls='ofiCollapse']").attr("aria-controls", "ofiCollapse-" + expanderCounter);
    }

    var jointStatusCounter = 0;
    function breakCheckboxName(fieldsClone) {
        $(fieldsClone).find("[name=joint_products_status]").attr("name", `joint_products_status_${jointStatusCounter++}`);
    }

    // when adding/removing a section the number of the sections header need to be updated.
    function fixLiabilityHeaders() {
        $container.find(".ofi-expander-item-header").each(function (index) {
            var text = $(this).text(),
                num = Number(text.split(' ')[1]),
                newText = text.replace(num, ++index);

            //index starts from 0
            $(this).text(newText);

            $(this).closest(".card-header").find(".remove-liability-button .sr-only").text(newText);
        });

        //The number of liabilities should be limited to 20
        if (liabilitiesCount >= 20) {
            $($addLiabilityButton).hide();
        }
        else {
            $($addLiabilityButton).show();
        }
    }

    function expandFirstItem(currentExpanderItem) {
        $(currentExpanderItem).find('.js-toggle').collapse('toggle');
    }

    function addLiabilitySection() {
        liabilitiesCount++;
       
        var fieldsClone = $("#ofi-form-template").children().first().clone(true, true);
        var expanderContent = $(fieldsClone).find('.ofi-expander-item-content');

        fixAttributes(expanderContent);
        fixExpanderAttributes(fieldsClone);
        breakCheckboxName(fieldsClone);

        $container.append(fieldsClone);

        expandFirstItem(fieldsClone);

        fixLiabilityHeaders();

        attachRemoveFunctionality();
        fixJointButtonsAccessibility(fieldsClone[0]);

        $(".remove-liability-button").last().focus();

        expanderCounter++;
    }

    function attachRemoveFunctionality() {
        $(".remove-liability-button").last().on("click", function (e) {
            e.preventDefault ? e.preventDefault() : e.returnValue = false;
            var element = $(e.target);

            element = element.closest('.ofi-expander-item');

            element.remove();

            liabilitiesCount--;

            if ($container.find('.ofi-expander-item').length === 0) {
                $($addLiabilityButton).hide();
                //force check 'No' on initial radio button
                $productsRadioSelector.each(function (index, el) {
                    if (!$(el).prop("checked")) {
                        $(el).click();
                    }
                });
            }

            var yesNoInputsShouldBeCheckedSelector = '.ofi_liabilities_container label.btn[role=radio].active input[type=radio]';
            $(yesNoInputsShouldBeCheckedSelector).prop("checked", true);

            fixLiabilityHeaders();
        });
    }

    function fixJointButtonsAccessibility(fieldsClone) {
        var radioButtons = fieldsClone.querySelectorAll("label input[name^='joint_products_status']");

        if (radioButtons.length) {
            for (var i = 0; i < radioButtons.length; i++) {
                var radioButtonLabel = radioButtons[i].parentElement;

                radioButtonLabel.addEventListener('click', setAccesibilityAttributesModule.clickRadioGroup);
                radioButtonLabel.addEventListener('keydown', setAccesibilityAttributesModule.keyDownRadioGroup);
            }
        }
    }

    function init() {
        // true, true -> makes a deep copy of the children and copy the events
        var fieldsCloneInitial = $($container.children().first()).clone(true, true);

        //we don't want initial Liability
        $($container.children().first()).remove();
        //hide addLiabilityButton initially
        $($addLiabilityButton).hide();

        var handlebarsHTML = document.getElementById('ofi-form-handlebars-template').innerHTML;
        var template = Handlebars.compile(handlebarsHTML);

        var contextObj = {
            expanderItemContent: fieldsCloneInitial.html()
        };

        var compiledData = template(contextObj);

        $("#ofi-form-template").prepend(compiledData);

        //without this expander items won't expand/collapse
        $container.attr('id', 'ofi-expander');

        //show first liability on radio group 'yes' check
        $productsRadioSelector.on('change', function () {
            var radioValue = $(this).val();
            if (radioValue.toLowerCase().includes("yes")) {
                if ($container.children().length === 0) {
                    addLiabilitySection();

                    $($addLiabilityButton).show();
                    if (!$(this).attr("touched")) {
                        $($addLiabilityButton).click(function () { addLiabilitySection(); });
                    }
                }
            } else if (radioValue.toLowerCase().includes("no")) {
                //reset count
                liabilitiesCount = 0;
                $($addLiabilityButton).hide();
                $container.empty();
            }
            $(this).attr("touched", "touched");
        });

        attachRemoveFunctionality();
    }

    if ($productsRadioSelector.length) {
        init();
    }
})();
